import {
    apiRequest,
    rekomendasi,
    rekomendasiselected,
    workunitall,
    createrekomendasimutasi,
    rekomendasihistory,
    position,
    employee,
    delmutasi,
    prosesdata,
    tabelriwayat,
    exportproccess,
    exportproccesshistory
} from "../../../../../services/adapters/kepegawaian/mappingMasaKerjaService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", rekomendasi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableSelected = async (query, cancelToken) => {
        return await apiRequest("get", rekomendasiselected, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableHistory = async (query, cancelToken) => {
        return await apiRequest("get", rekomendasihistory, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchExport = async (query, cancelToken) => {
        return await apiRequest("get", exportproccess, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchExportHistory = async (query, cancelToken) => {
        return await apiRequest("get", exportproccesshistory, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRowTableRiwayat = async (query, cancelToken) => {
        return await apiRequest("get", tabelriwayat, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchWorkUnit = async (query, cancelToken) => {
        return await apiRequest("get", workunitall, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchCreate = async (query, cancelToken) => {
        return await apiRequest("post", createrekomendasimutasi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchProses = async (query, cancelToken) => {
        return await apiRequest("post", prosesdata, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchPosition = async (query, cancelToken) => {
        return await apiRequest("get", position, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchEmployee = async (query, cancelToken) => {
        return await apiRequest("get", employee, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchDelMapping = async (query, cancelToken) => {
        return await apiRequest("get", delmutasi, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository